import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { InviteService } from "../../service/InviteService.ts";
const initialState = {
    loading: false,
    verifiedInviteResponse: {},
    readInvite: [],
};
const action = {
    createInvite: createAsyncThunk("invite/createInvite", async (payload, thunkAPI) => {
        return (await InviteService.invite(thunkAPI, payload.data)).data;
    }),
    verifyInvite: createAsyncThunk("invite/verifyInvite", async (payload, thunkAPI) => {
        return (await InviteService.verifyInvite(thunkAPI, payload)).data;
    }),
    readInvite: createAsyncThunk("invite/readInvite", async (_, thunkAPI) => {
        return (await InviteService.readInvite(thunkAPI)).data;
    }),
    inviteRegistration: createAsyncThunk("invite/inviteRegistration", async (payload, thunkAPI) => {
        return (await InviteService.inviteRegistration(thunkAPI, payload.data)).data;
    }),
    resendInvite: createAsyncThunk("invite/resendInvite", async (payload, thunkAPI) => {
        return (await InviteService.resendInvite(thunkAPI, payload.data)).data;
    })
};
const slice = createSlice({
    name: "invite",
    initialState,
    reducers: {
        setLoading(state, { payload }) {
            state.loading = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.createInvite.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.createInvite.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.verifyInvite.pending, (state) => {
            state.loading = true;
        }).addCase(action.verifyInvite.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                state.verifiedInviteResponse = response.data;
            }
        }).addCase(action.readInvite.pending, (state) => {
            state.loading = true;
        }).addCase(action.readInvite.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                state.readInvite = response.data;
            }
        }).addCase(action.resendInvite.pending, (state) => {
            state.loading = true;
        }).addCase(action.resendInvite.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode == "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            .addCase(action.inviteRegistration.pending, (state) => {
            state.loading = true;
        }).addCase(action.inviteRegistration.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        });
    },
});
export const invite = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
